/*global $, define*/
'use strict';
define('core/directives/dnaTncDirective',['angular',
    'core/services/UserService'], function (angular) {
    angular.module('dnaApp').directive('dnaTnc', ['$location', 'UserService', '$rootScope', '$log',
        function ($location, UserService, $rootScope, $log) {
            return {
                link: function ($scope) {
                    $scope.tncLoaded = false;
                    $scope.tncAccepted = false;

                    function showTncPage() {
                        $location.replace();
                        UserService.preTncPath = $location.path();
                        $location.path('/tnc');
                    }

                    function loadTncSetting() {
                        UserService.acceptedTerms().then(
                            function (tnc) {
                                if (!tnc.tandCTimeStamp) {
                                    $scope.tncLoaded = true;
                                    $scope.tncAccepted = false;
                                    showTncPage();
                                } else {
                                    $scope.tncAccepted = true;
                                }
                            },
                            function (errorResponse) {
                                if (errorResponse.status !== 426) {
                                    $log.error('URL - ' + errorResponse.config.url + ' got response ' + errorResponse.status);
                                    $scope.tncLoaded = false;
                                    showTncPage();
                                }
                            }
                        );
                    }

                    loadTncSetting();
                }
            };
        }]);
});

